import { merge } from 'lodash';
import { getEntries } from 'lib/contentful-client';

// const slug = !match.params || !match.params.slug ? '' : match.params.slug;
// const blogUrl = match.url.split('/')[1].replace(/\/$/, '') + '/';
// const currentPage = !slug ? 'home' : getPageTypeBySlug(slug);

export const getVideoEntries = async queryParams => {
  const query = merge(
    {
      call_name: 'cda.getEntries',
      params: {
        content_type: 'video',
        order: '-sys.createdAt',
        limit: 1,
        skip: 0,
      },
    },
    queryParams
  );
  try {
    const entries = await getEntries(null, query);

    return entries?.items && Array.isArray(entries?.items)
      ? entries.items.map(item => ({
          slug: item?.fields?.slug || item.sys.id,
          category: item.fields?.primaryCategory
            ? item.fields?.primaryCategory
            : item.fields?.categories[0] || '',
          categories: item.fields?.categories,
          description: item.fields.description,
          image: item.fields.thumbnail,
          isRecordedLive: item.fields.categories.includes('Recorded Live'),
          isPlayingLive: false,
          products: item.fields?.products,
          // title: item.sys.id + ':' + item.fields?.title,
          title: item.fields?.title,
          videoId: item.fields?.videoId,
          videoLength: item.fields?.videoLength,
          videoType: item.fields?.videoId
            ? /[a-z]/.test(item.fields?.videoId)
              ? 'wistia'
              : 'vimeo'
            : '',
          skuBuilder: item.fields?.skuBuilder || [],
        }))
      : [];
  } catch (e) {
    return [];
  }
};

export const videoCategoryList = () => {
  const categories = [
    'Product Spotlight',
    'Styling & Tutorials',
    'Customer Care & FAQs',
    'Recorded Live',
  ];
  categories.sort().unshift('All');

  return categories.map(category => ({
    label: category,
    id: category.replace(/\W+/g, '-').toLowerCase(),
  }));
};

export const getLabelForId = (filters = [], id) => {
  const filter = filters.find(currentFilter => currentFilter.id === id);
  return filter ? filter.label : '';
};
